import React from 'react';
import {useState, useEffect} from 'react';

import {A, Img, Separator, Button} from 'views/AppElements';
import SetoCanvasPage from 'pages/SetoCanvasPage';

import ProductAPI from 'service/api/ProductAPI';
import ProductStore from 'stores/ProductStore';
import ProductList from 'views/product/ProductList';

import AppConstants from '../../AppConstants';
import AppUtil from 'AppUtil';

const photoframe = AppConstants.PRODUCT_TYPES.PHOTO_FRAME.url;

function DashainFramePage(props) {
    const [products, setProducts] = useState(ProductStore.getProductsByType(photoframe));


    useEffect(() => {
        const listener = ProductStore.addListener(() => {
			setProducts(ProductStore.getProductsByType(photoframe));
		});

        if(!products) {
            const productType = AppUtil.findProductTypeFromURL(photoframe);
            ProductAPI.getProductsByType(productType, 0, AppConstants.DEFAULT_PRODUCT_PAGE_SIZE);
        }
        
        return () => listener.remove();
    }, []);

    const shuffledProducts = products? products.sort(() => .5 - Math.random()): products;
    
    return <SetoCanvasPage id="dashainFramePage" title="Get your Family Picture Framed at 30% Discount | Seto Canvas" metaDescription="Get your Family Picture Framed at 40% Discount at setocanvas.com">
            
            <div className="flexRow campaignContainer">
                <div id="discountInfo">
                    {/* <h2>Frame your family picture with us and get <b>30%</b> discount on all sizes: </h2>
                    <Separator /> */}
                    <h4 style={{margin: '20px 0'}}>Upload your picture and apply coupon code <span style={{color: '#f89516', fontWeight: 'bold', textDecoration: 'underline', fontSize: '120%', margin: '0 5px'}}><b>DASHAIN_TIHAR_79</b></span> to get 30% discount on frames of all sizes.</h4>
                    <Button id="uploadPicBtn" href="/custom-order/photo-frame" mui='true' color='primary'>
                        <i className="fa fa-cloud-upload" aria-hidden="true"></i> Upload Your Picture
                    </Button>
                    <h4><small>Offer Valid until Nov 16, 2022 / Karthik 30, 2079</small></h4>
                </div>
                
                {/* <div id="framePriceInfo">
                    <table>
                        <thead>
                            <tr>
                                <th colSpan="2">Use Coupon Code</th> 
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td colSpan="2" style={{textAlign: 'center'}}>DASHAIN_TIHAR_79</td> 
                            </tr>
                            
                        </tbody>
                    </table>
                </div> */}
            </div>
            <Separator />
            <Img src="/images/banners/dashain/Dashain-PhotoFrame.jpg?v=1.1" />
            


            <div className="mainContainer">
                <h2 style={{color: 'darkcyan', paddingTop: '10px', borderTop: '1px solid gray'}}>Popular Frames! <small><A href="/shop/photoframe">View All <i className="fa fa-external-link" aria-hidden="true"></i></A></small></h2>

                <ProductList products={shuffledProducts} showSlider={true} 
							autoplay={true} navigator="arrows" 
							flattenProductImages={true} />
            </div>
    </SetoCanvasPage>
}


export default DashainFramePage;


// WEBPACK FOOTER //
// ./src/pages/campaigns/DashainFrame.js